{
  "COMPOSE_REDIRECT": {
    "OPENING": "Avataan uutta keskustelua käyttäjän {email} kanssa…",
    "NO_EMAIL": "Sähköpostiosoitetta ei annettu. Käytä ?email=name@example.com",
    "CONTACT_ERROR": "Yhteystietoa käyttäjälle {email} ei löytynyt."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Ole hyvä ja valitse keskustelu vasemmasta paneelista",
    "CSAT_REPLY_MESSAGE": "Voisitko antaa palautetta saamastasi palvelusta?",
    "404": "Sorry, we cannot find the conversation. Please try again",
    "SWITCH_VIEW_LAYOUT": "Switch the layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Messages",
    "UNVERIFIED_SESSION": "The identity of this user is not verified",
    "NO_MESSAGE_1": "Voi voi! Näyttää siltä, että postilaatikossasi ei ole viestejä.",
    "NO_MESSAGE_2": " jotta voit lähettää viestin sivullesi!",
    "NO_INBOX_1": "Hola! Näyttää siltä, että et ole vielä lisännyt yhtään saapuneet-kansiota.",
    "NO_INBOX_2": " päästäksesi alkuun",
    "NO_INBOX_AGENT": "Voi ei! Näyttää siltä, että et kuulu mihinkään saapuneet-kansioon. Ota yhteyttä työnantajaasi",
    "SEARCH_MESSAGES": "Etsi viestejä keskusteluissa",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Käännös",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Etsi viestejä",
      "RESULT_TITLE": "Search Results",
      "LOADING_MESSAGE": "Rouskutetaan dataa...",
      "PLACEHOLDER": "Kirjoita mikä tahansa teksti etsiäksesi viestejä",
      "NO_MATCHING_RESULTS": "No results found."
    },
    "UNREAD_MESSAGES": "Lukemattomat viestit",
    "UNREAD_MESSAGE": "Lukematon viesti",
    "CLICK_HERE": "Klikkaa tästä",
    "LOADING_INBOXES": "Ladataan saapuneet-kansioita",
    "LOADING_CONVERSATIONS": "Ladataan keskusteluita",
    "CANNOT_REPLY": "Et voi vastata, sillä",
    "24_HOURS_WINDOW": "24h vastausikkuna",
    "NOT_ASSIGNED_TO_YOU": "Tätä keskustelua ei ole määritetty sinulle. Haluatko siirtää tämän keskustelun itsellesi?",
    "ASSIGN_TO_ME": "Siirrä minulle",
    "TWILIO_WHATSAPP_CAN_REPLY": "You can only reply to this conversation using a template message due to",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24h vastausikkuna",
    "REPLYING_TO": "Olet vastaamassa:",
    "REMOVE_SELECTION": "Poista valinnat",
    "DOWNLOAD": "Lataa",
    "UNKNOWN_FILE_TYPE": "Unknown File",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Suorita ennen lähettämistä:",
      "EXECUTE": "Suorita",
      "RETRY": "Yritä uudelleen",
      "CONFIRM": "Suoritetaanko nyt?",
      "CONFIRM_YES": "Kyllä, suorita",
      "CONFIRM_NO": "Peruuta",
      "RUNNING": "Suoritetaan…",
      "DONE": "Valmis",
      "CLAIM_DELAYED": "tehdään, kun tilaus on toimitettu",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Luotu UUSI reklamaatio {reference}, {planned} on suljettu — muokkaa luonnoksen tekstiä",
        "NEW_CLAIM": "Luotu UUSI reklamaatio {reference} tunnuksen {planned} päivittämisen sijaan — muokkaa luonnoksen tekstiä",
        "OTHER_CLAIM": "Päivitetty reklamaatio {reference} tunnuksen {planned} sijaan — muokkaa luonnoksen tekstiä",
        "EXISTING_CLAIM": "Uutta reklamaatiota ei luotu, päivitettiin olemassa oleva {reference} — muokkaa luonnoksen tekstiä",
        "OTHER": "Tapahtui toisin kuin luonnos oletti — muokkaa luonnoksen tekstiä"
      },
      "FAILED": "Epäonnistui",
      "UNREACHABLE": "Bottiin ei saatu yhteyttä",
      "REQUEST_FAILED": "Toimintoa ei voitu käynnistää, yritä uudelleen.",
      "ACTIONS": {
        "CANCEL_ORDER": "Peruuta tilaus",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Vaihda maksutapa jälkivaatimukseksi",
        "CREATE_CLAIM": "Tee reklamaatio",
        "CREATE_OR_UPDATE_CLAIM": "Tee tai päivitä reklamaatio",
        "EXTEND_ORDER_PICKUP_DATE": "Pidennä noutoaikaa"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Ladataan liitteitä...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Message deleted successfully",
    "FAIL_DELETE_MESSSAGE": "Couldn't delete message! Try again",
    "NO_RESPONSE": "No response",
    "RESPONSE": "Response",
    "RATING_TITLE": "Arvio",
    "FEEDBACK_TITLE": "Palaute",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Show labels",
      "HIDE_LABELS": "Hide labels"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Ratkaise",
      "REOPEN_ACTION": "Uudelleenavaa",
      "OPEN_ACTION": "Avaa",
      "OPEN": "Näytä",
      "CLOSE": "Sulje",
      "DETAILS": "tiedot",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Snoozed until tomorrow",
      "SNOOZED_UNTIL_NEXT_WEEK": "Snoozed until next week",
      "SNOOZED_UNTIL_NEXT_REPLY": "Snoozed until next reply",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Mark as pending",
      "SNOOZE_UNTIL": "Snooze",
      "SNOOZE": {
        "TITLE": "Snooze until",
        "NEXT_REPLY": "Next reply",
        "TOMORROW": "Tomorrow",
        "NEXT_WEEK": "Next week"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Snooze until",
      "APPLY": "Snooze",
      "CANCEL": "Peruuta"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "Ei mitään",
        "URGENT": "Kiireellinen",
        "HIGH": "Korkea",
        "MEDIUM": "Keskitaso",
        "LOW": "Matala"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "None",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "No results found",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Avaa uudessa välilehdessä",
      "COPY_LINK": "Kopioi keskustelun linkki",
      "COPY_LINK_SUCCESS": "Keskustelun linkki kopioitu leikepöydälle",
      "PENDING": "Mark as pending",
      "RESOLVED": "Mark as resolved",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Avaa keskustelu uudelleen",
      "SNOOZE": {
        "TITLE": "Snooze",
        "NEXT_REPLY": "Until next reply",
        "TOMORROW": "Until tomorrow",
        "NEXT_WEEK": "Until next week"
      },
      "ASSIGN_AGENT": "Assign agent",
      "ASSIGN_LABEL": "Assign label",
      "AGENTS_LOADING": "Loading agents...",
      "ASSIGN_TEAM": "Assign team",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Conversation id {conversationId} assigned to \"{agentName}\"",
          "FAILED": "Couldn't assign agent. Please try again."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Couldn't assign label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Assigned team \"{team}\" to conversation id {conversationId}",
          "FAILED": "Couldn't assign team. Please try again."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Message signature",
      "ENABLE_SIGN_TOOLTIP": "Enable signature",
      "DISABLE_SIGN_TOOLTIP": "Disable signature",
      "MSG_INPUT": "Vaihto + enter siirtyäksesi uudelle riville. Aloita '/' valitaksesi tallennettu vastaus.",
      "PRIVATE_MSG_INPUT": "Vaihto + enter siirtyäksesi uudelle riville. Tämä näkyy vain edustajille",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Message signature is not configured, please configure it in profile settings.",
      "CLICK_HERE": "Click here to update",
      "WHATSAPP_TEMPLATES": "WhatsApp-pohjat",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "WhatsAppin 24 tunnin aikaikkuna on umpeutunut. Vastaa viestipohjalla.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Vastauksesi näyttää olevan kielellä {draftLanguage}, mutta tämä keskustelu on kielellä {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Käännä",
      "REPLY": "Vastaa",
      "PRIVATE_NOTE": "Sisäinen merkintä",
      "SEND": "Lähetä",
      "CREATE": "Lisää muistiinpano",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_FORMAT_ICON": "Show rich text editor",
      "HEADING_LEVEL": {
        "LABEL": "Tekstityyli",
        "NORMAL": "Normaali teksti",
        "H1": "Otsikko 1",
        "H2": "Otsikko 2",
        "H3": "Otsikko 3"
      },
      "EDITOR": {
        "BOLD": "Lihavointi",
        "ITALIC": "Kursivointi",
        "UNDERLINE": "Alleviivaus",
        "TEXT_COLOR": "Tekstin väri",
        "BG_COLOR_LABEL": "Taustaväri",
        "FONT_SIZE_LABEL": "Fontin koko",
        "FONT_SIZE": {
          "XS": "Pieni",
          "SM": "Keskipieni",
          "MD": "Oletus",
          "LG": "Suuri",
          "XL": "Erittäin suuri",
          "XXL": "Valtava"
        },
        "CODE": "Koodi",
        "LINK": "Lisää tai poista linkki",
        "CREATE_LINK": "Luo linkki",
        "SAVE_LINK": "Tallenna",
        "CANCEL": "Peruuta",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Kumoa",
        "REDO": "Tee uudelleen",
        "BULLET_LIST": "Luettelomerkit",
        "ORDERED_LIST": "Numeroitu luettelo",
        "BLOCKQUOTE": "Lainaus",
        "H1": "Otsikko 1",
        "H2": "Otsikko 2",
        "H3": "Otsikko 3",
        "IMAGE_UPLOAD": "Lataa kuva",
        "CLEAR_FORMATTING": "Poista muotoilu",
        "COLOR": {
          "RED": "Punainen",
          "YELLOW": "Keltainen",
          "BLUE": "Sininen",
          "ROSE_RED": "Ruusunpunainen",
          "DEEP_CYAN": "Tumma syaani",
          "ORANGE": "Oranssi",
          "PISTACHIO": "Pistaasi",
          "PURPLE": "Violetti",
          "FUCHSIA": "Fuksia",
          "SILVER": "Hopea",
          "NAVY": "Laivastonsininen",
          "OLD_PINK": "Vanha roosa",
          "AQUA": "Vesi",
          "BROWN": "Ruskea",
          "OLIVE": "Oliivi",
          "GOLD": "Kulta",
          "BEIGE": "Beige",
          "WINE": "Viininpunainen",
          "FOREST": "Metsänvihreä",
          "GREEN": "Vihreä",
          "BLUE_GREY": "Siniharmaa",
          "RUBY_RED": "Rubiininpunainen",
          "CHESTNUT_BROWN": "Kastanjanruskea",
          "ASH_GREY": "Tuhkanharmaa"
        },
        "BG_COLOR": {
          "RED": "Punainen",
          "YELLOW": "Keltainen",
          "BLUE": "Sininen",
          "ROSE_RED": "Ruusunpunainen",
          "DEEP_CYAN": "Tumma syaani",
          "ORANGE": "Oranssi",
          "PISTACHIO": "Pistaasi",
          "PURPLE": "Violetti",
          "FUCHSIA": "Fuksia",
          "SILVER": "Hopea",
          "NAVY": "Laivastonsininen",
          "OLD_PINK": "Vanha roosa",
          "AQUA": "Vesi",
          "BROWN": "Ruskea",
          "OLIVE": "Oliivi",
          "GOLD": "Kulta",
          "BEIGE": "Beige",
          "WINE": "Viininpunainen",
          "FOREST": "Metsänvihreä",
          "GREEN": "Vihreä",
          "BLUE_GREY": "Siniharmaa",
          "RUBY_RED": "Rubiininpunainen",
          "CHESTNUT_BROWN": "Kastanjanruskea",
          "ASH_GREY": "Tuhkanharmaa"
        }
      },
      "TIP_EMOJI_ICON": "Show emoji selector",
      "TIP_ATTACH_ICON": "Attach files",
      "TIP_AUDIORECORDER_ICON": "Record audio",
      "TIP_AUDIORECORDER_PERMISSION": "Allow access to audio",
      "TIP_AUDIORECORDER_ERROR": "Could not open the audio",
      "DRAG_DROP": "Drag and drop here to attach",
      "START_AUDIO_RECORDING": "Start audio recording",
      "STOP_AUDIO_RECORDING": "Stop audio recording",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Add bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Lähetä",
          "CANCEL": "Peruuta"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Lisää SMS-saapuneet-kansio lähettääksesi SMS-vastauksia.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Yksityinen huomautus: Näkyy vain sinulle ja tiimillesi",
    "CHANGE_STATUS": "Keskustelun tila muutettu",
    "CHANGE_STATUS_FAILED": "Conversation status change failed",
    "CHANGE_AGENT": "Keskustelun vastaanottaja vaihdettu",
    "CHANGE_AGENT_FAILED": "Assignee change failed",
    "ASSIGN_LABEL_SUCCESFUL": "Label assigned successfully",
    "ASSIGN_LABEL_FAILED": "Label assignment failed",
    "CHANGE_TEAM": "Conversation team changed",
    "FILE_SIZE_LIMIT": "File exceeds the {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB attachment limit",
    "MESSAGE_ERROR": "Unable to send this message, please try again later",
    "SENT_BY": "Lähettäjä:",
    "BOT": "Botti",
    "SEND_FAILED": "Viestiä ei voitu lähettää! Yritä uudelleen",
    "TRY_AGAIN": "retry",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Valitse edustaja",
      "REMOVE": "Poista",
      "ASSIGN": "Delegoi"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopioi",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Poista",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Poista",
        "CANCEL": "Peruuta"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Contact",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "{userName} merkitsi keskustelun ratkaistuksi",
          "CONTACT_RESOLVED": "Conversation was resolved by {contactName}",
          "OPEN": "{userName} uudelleenavasi keskustelun",
          "PENDING": "Conversation was marked as pending by {userName}",
          "SNOOZED": "Conversation was snoozed by {userName}",
          "AUTO_RESOLVED": "Keskustelu merkittiin ratkaistuksi automaattisesti, sillä on kulunut {duration} päivää viimeisestä viestistä",
          "SYSTEM_AUTO_OPEN": "System reopened the conversation due to a new incoming message.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Järjestelmä ratkaisi keskustelun, koska tiketti suljettiin Kauflandissa."
        },
        "PRIORITY": {
          "ADDED": "{userName} set the priority to {newPriority}",
          "UPDATED": "{userName} changed the priority from {oldPriority} to {newPriority}",
          "REMOVED": "{userName} removed the priority"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} ilmottautui keskusteluun",
          "ASSIGNED": "Delegoitu edustajalle {assigneeName} edustajan {userName} toimesta",
          "REMOVED": "{userName} poistui keskustelusta"
        },
        "TEAM": {
          "ASSIGNED": "Delegoitu edustajalle {teamName} edustajan {userName} toimesta",
          "ASSIGNED_WITH_ASSIGNEE": "Assigned to {assigneeName} via {teamName} by {userName}",
          "REMOVED": "Unassigned from {teamName} by {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} lisäsi tunnisteet {labels}",
          "REMOVED": "{userName} poisti tunnisteet {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} mykisti keskustelun",
        "UNMUTED": "{userName} poisti keskustelun mykistyksen",
        "CONTACT_BLOCKED": "{userName} esti yhteystiedon",
        "CONTACT_UNBLOCKED": "{userName} poisti yhteystiedon eston",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Siirretty, koska yhteyshenkilön tilaukset ovat vain verkkokaupasta {storeName} (viimeisin tilaus {orderId}), jonka robotti vastaa tässä postilaatikossa.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automaatio ohitettiin, koska yhteystieto on estetty",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automaatio \"{ruleName}\" ei voinut siirtää tätä keskustelua kansiosta {sourceInboxName} kansioon {targetInboxName}, koska kansiot eivät ole yhteensopivia.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automaatio \"{ruleName}\" ei voinut siirtää tätä keskustelua kansiosta {sourceInboxName} kansioon {targetInboxName}, koska yhteystiedolla ei ole sähköpostiosoitetta.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automaatio \"{ruleName}\" ei voinut lähettää viestiä: tämä puhelinkansio ei voi lähettää tekstiviestejä, koska tilillä ei ole tekstiviestikansiota. Sääntö poistettiin käytöstä ja ylläpitäjät saivat sähköpostiviestin.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automaatio \"{ruleName}\" ei voinut lähettää viestiä: liitteitä ei voi lähettää tekstiviestinä tästä saapuneet-kansiosta. Sääntö poistettiin käytöstä ja ylläpitäjät saivat sähköpostiviestin.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Makro \"{macroName}\" ei lähettänyt viestiään: tämä puhelinkansio ei voi lähettää tekstiviestejä, koska tilillä ei ole tekstiviestikansiota.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Makro \"{macroName}\" ei lähettänyt viestiään: liitteitä ei voi lähettää tekstiviestinä tästä saapuneet-kansiosta.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Makro \"{macroName}\" ei lähettänyt viestiään: botti hoitaa tätä keskustelua. Avaa keskustelu ensin.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Makro \"{macroName}\" ei lähettänyt viestiään: tämä saapuneet-kansio on merkitty poistettavaksi. Siirrä keskustelu ensin toiseen saapuneet-kansioon.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automaatio \"{ruleName}\" lähetti sähköpostin osoitteeseen {contactEmail} uudessa keskustelussa [#{conversationId}]({conversationPath}) kansiossa {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automaatio \"{ruleName}\" aloitti tämän keskustelun kansion {inboxName} keskustelun [#{conversationId}]({conversationPath}) vuoksi.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automaatio \"{ruleName}\" ei voinut lähettää viestiä uudessa keskustelussa kansiossa {inboxName}, koska yhteystiedolla ei ole sähköpostiosoitetta.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automaatio \"{ruleName}\" lähetti tekstiviestin numeroon {contactPhone} uudessa keskustelussa [#{conversationId}]({conversationPath}) kansiossa {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automaatio \"{ruleName}\" ei voinut lähettää tekstiviestiä uudessa keskustelussa kansiossa {inboxName}, koska yhteystiedolla ei ole puhelinnumeroa.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agentti",
            "CUSTOMER": "Asiakas"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "vastattu muualla, soi {duration}",
            "NO_ANSWER": "ei vastattu, soi {duration}",
            "REJECTED": "hylätty, soi {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Ratkaistu automaattisesti epäonnistuneiden takaisinsoittojen määrän ({count}) jälkeen",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Puhelun tallenne poistettu: {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Näkymätön asiakkaalle",
    "SENT_VIA_EMAIL": "Lähetetty yhteystiedolle myös sähköpostitse ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Tämä saapuneet-kansio on merkitty poistettavaksi, joten asiakkaan vastaus ei koskaan saapuisi perille. Siirrä keskustelu toiseen saapuneet-kansioon vastataksesi.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Tällä yhteystiedolla on toinen avoin keskustelu #{id}",
      "MULTIPLE": "Tällä yhteystiedolla on muita avoimia keskusteluja ({count})",
      "OPEN": "Avaa",
      "SHOW": "Näytä"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Pyydä asiakasta jakamaan WhatsApp-puhelinnumeronsa",
      "PENDING_ACTION": "Yhteystietopyyntö odottaa",
      "STATES": {
        "PENDING": "Odottaa yhteystietoja",
        "SHARED": "Puhelinnumero jaettu",
        "IDENTITY_CONFLICT": "Puhelinnumero vaatii tarkistuksen"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Lähetä keskustelu",
    "DESC": "Lähetä kopio keskustelu määritettyyn sähköpostiosoitteeseen",
    "SUBMIT": "Lähetä",
    "CANCEL": "Peruuta",
    "SEND_EMAIL_SUCCESS": "Chat-keskustelu on lähetetty onnistuneesti",
    "SEND_EMAIL_ERROR": "Tapahtui virhe, yritä uudelleen",
    "FORM": {
      "SEND_TO_CONTACT": "Lähetä keskustelu asiakkaalle",
      "SEND_TO_AGENT": "Lähetä keskustelu edustajalle",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Lähetä keskustelu muuhun sähköpostiin",
      "EMAIL": {
        "PLACEHOLDER": "Anna sähköpostiosoite",
        "ERROR": "Ole hyvä ja syötä validi sähköposti"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hey 👋, Welcome to {installationName}!",
    "DESCRIPTION": "Thanks for signing up. We want you to get the most out of {installationName}. Here are a few things you can do in {installationName} to make the experience delightful.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Read our latest updates",
    "ALL_CONVERSATION": {
      "TITLE": "All your conversations in one place",
      "DESCRIPTION": "View all the conversations from your customers in one single dashboard. You can filter the conversations by the incoming channel, label and status.",
      "NEW_LINK": "Click here to create an inbox"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Invite your team members",
      "DESCRIPTION": "Since you are getting ready to talk to your customer, bring in your teammates to assist you. You can invite your teammates by adding their email addresses to the agent list.",
      "NEW_LINK": "Click here to invite a team member"
    },
    "LABELS": {
      "TITLE": "Organize conversations with labels",
      "DESCRIPTION": "Labels provide an easier way to categorize your conversation. Create some labels like #support-enquiry, #billing-question etc., so that you can use them in a conversation later.",
      "NEW_LINK": "Click here to create tags"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Osoitettu Edustajalle",
    "SELF_ASSIGN": "Siirrä minulle",
    "TEAM_LABEL": "Osoitettu Tiimille",
    "SELECT": {
      "PLACEHOLDER": "None"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Contact Details",
      "CONVERSATION_ACTIONS": "Keskustelutoiminnot",
      "CONVERSATION_LABELS": "Keskustelutunnisteet",
      "CONVERSATION_INFO": "Keskustelun Tiedot",
      "CONTACT_ATTRIBUTES": "Yhteystiedon määritteet",
      "PREVIOUS_CONVERSATION": "Edelliset keskustelut",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Odottava",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Create attribute",
    "NO_RECORDS_FOUND": "Määritteitä ei löytynyt",
    "UPDATE": {
      "SUCCESS": "Tunniste päivitetty onnistuneesti",
      "ERROR": "Attribuuttia ei voida päivittää. Yritä myöhemmin uudelleen"
    },
    "ADD": {
      "TITLE": "Add",
      "SUCCESS": "Attribuutin lisäys onnistui",
      "ERROR": "Attribuuttia ei voitu lisätä. Yritä myöhemmin uudelleen"
    },
    "DELETE": {
      "SUCCESS": "Attribuutin poisto onnistui",
      "ERROR": "Attribuuttia ei voida poistaa. Yritä uudelleen myöhemmin"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Lisää määritteitä",
      "PLACEHOLDER": "Etsi määritteitä",
      "NO_RESULT": "Määritteitä ei löytynyt"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "From",
    "TO": "To",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Subject"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "No results found",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Tilausnumero",
    "EXTERNAL_ID": "Ulkoinen tunniste",
    "PAYMENT_TYPE": "Maksutapa",
    "PAYMENT_DATE": "Maksupäivä",
    "DELIVERY_PROVIDER": "Toimittaja",
    "EXPECTED_DATE_OF_DELIVERY": "Arvioitu toimitus",
    "DATE_OF_DELIVERY": "Toimitettu",
    "EXPEDITION_DATE": "Lähetyspäivä",
    "INTERNAL_NOTE": "Kaupan huomautus",
    "PACKAGE_NUMBER": "Lähetys"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
